import cookies from 'js-cookie';

export const removeBetaFeaturesCookie = (): void => {
  cookies.remove('development-beta-features');
};
